import { ActionList, Button, Popover } from '@shopify/polaris';
import { MobileVerticalDotsMajor } from '@shopify/polaris-icons';
import React, { useCallback, useEffect, useState } from 'react';
import { DI, DIProps } from '../../../../Core';
import { useTranslation } from "react-i18next";
interface Props extends DIProps {
    row: any;
    setactiontype: (data: any) => void;
    setsyncModal: (data: boolean) => void;
    syncModal: boolean;
    deleteModel: any;
}

const ProductWiseAction = (data: Props) => {
    const { t } = useTranslation();
    const { row, setactiontype, setsyncModal, syncModal, deleteModel } = data;
    const [rowWiseAction, setrowWiseAction] = useState<string>('');
    const [options, setoptions] = useState<any>([]);
    const [popoverActive, setPopoverActive] = useState(false);

    useEffect(() => {
        if (rowWiseAction == 'Auto Syncing') {
            setactiontype({
                title: 'Auto Sync Settings',
                product_id: row._id.$oid,
                description: 'Are you sure you want to unlink the product?',
                actionName: 'Save',
                checked: row?.hasOwnProperty('automate_sync') ? false : true,
            }),
                setsyncModal(true);
        } else if (rowWiseAction == 'Delete Product') {
            deleteModel?.handledeleteproduct(deleteModel?.val);
        }
    }, [rowWiseAction]);

    useEffect(() => {
        setrowWiseAction('');
        let option = [
            {
                content: t('Auto Sync off'),
                onAction: () => setrowWiseAction('Auto Syncing'),
            },
            {
                content: t('Delete Product'),
                destructive: true,
                onAction: () => setrowWiseAction('Delete Product'),
            },
        ];
        setoptions(option);
    }, [data, rowWiseAction]);

    const togglePopoverActive = useCallback(() => setPopoverActive((popoverActive) => !popoverActive), []);
    
    const activator = <Button onClick={togglePopoverActive} icon={MobileVerticalDotsMajor}></Button>
    return (
        <Popover
            active={popoverActive}
            activator={activator}
            autofocusTarget="first-node"
            onClose={togglePopoverActive}>
            <ActionList actionRole="menuitem" items={options} />
        </Popover>
    );
};

export default DI(ProductWiseAction);